import { Box } from '@mui/material'
import styles from './index.module.scss'

export default function AssistantMessageContentBody({ children, revealKey, refinementSourceText }) {
  return (
    <Box className={styles.inner} data-refinement-source="assistant-response" data-refinement-response-text={refinementSourceText}>
      <Box className={styles.frame}>
        <Box key={revealKey} className={styles.messageReveal} component="div">
          {children}
        </Box>
      </Box>
    </Box>
  )
}
